import { render, staticRenderFns } from "./UtxoThreshold.vue?vue&type=template&id=57ff535c&scoped=true&"
import script from "./UtxoThreshold.vue?vue&type=script&lang=ts&"
export * from "./UtxoThreshold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ff535c",
  null
  
)

export default component.exports